module.exports = __webpack_public_path__ + "img/wedigi.0d59b13d.svg";